/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ProjectImportsControllerCreateMutationResponse, ProjectImportsControllerCreate400, ProjectImportsControllerCreate401, ProjectImportsControllerCreate403 } from "../../models/projectsController/ProjectImportsControllerCreate";

function getProjectImportsControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/project-imports` as const }  
  return res
}

/**
 * @description Validates the reviewed XLSX hash, creates missing relationships, refreshes the preview, and creates projects synchronously.
 * @summary Execute a reviewed project spreadsheet import
 * {@link /api/v1/project-imports}
 */
export async function projectImportsControllerCreate(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ProjectImportsControllerCreateMutationResponse, ResponseErrorConfig<ProjectImportsControllerCreate400 | ProjectImportsControllerCreate401 | ProjectImportsControllerCreate403>, unknown>({ method : "POST", url : getProjectImportsControllerCreateUrl().url.toString(), ... requestConfig })  
  return res.data
}